import { getPatientEventStatus } from './getPatientEventStatus.js';
import { isPatientVisibleEvent } from './isPatientVisibleEvent.js';
export function getPatientChatState(chat) {
    let status;
    let lastEvent;
    for (let i = chat.length - 1; i >= 0; i--) {
        const event = chat[i];
        status ??= getPatientEventStatus(event);
        if (lastEvent === undefined && isPatientVisibleEvent(event)) {
            lastEvent = event;
        }
        if (status !== undefined && lastEvent !== undefined) {
            break;
        }
    }
    const lastSeq = chat.length > 0 ? chat[chat.length - 1].seq : undefined;
    return {
        status: status ?? 'HIDDEN',
        lastEvent,
        lastSeq,
    };
}
//# sourceMappingURL=getPatientChatState.js.map